module.exports = __webpack_public_path__ + "Flag-384.c77a2bb3dfb3545718e2fc23fd56a85a.svg";